<template>
  <div class="mt-preview-container">
    <div class="pc-preview-background">
      <img
        alt="phone-empty"
        src="@shared/assets/img/partner-detail/pro-app.png"
        class="pc-phone-img"
      >
      <div
        class="pc-header-overlay "
      >
        {{ partnerName }}
      </div>
      <div class="pc-absolute-overlay">
        <MyTechPreviewItem
          sub="Set up new service"
          imageSrc="onboarding"
          class="margin-top-4"
        />
        <MyTechPreviewItem
          v-if="isMyTech === 'yes'"
          sub="MyTech Chats"
          imageSrc="my-tech"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MyTechPreviewItem from './MyTechPreviewItem.vue';

export default {
  name: 'MyTechPreview',
  components: {
    MyTechPreviewItem,
  },
  props: {
    isMyTech: String,
    partnerName: String,
  },
};
</script>

<style lang="scss">

.mt-preview-container {
  margin-left: 24px;

  .pc-preview-background {
    position: relative;
    border-radius: 50px;
    background-color: $N100;
    height: 91%;
  }

  .pc-phone-img {
    height: 520px;
  }

  .pc-phone-item {
    height: 50px;
    padding: 10px
  }

  .pc-header-overlay {
    position: absolute;
    left: 20px;
    right: 15px;
    top: 60px;
    height: 400px;
    padding: 6px;
    font-weight: bold;
  }

  .pc-absolute-overlay {
    position: absolute;
    left: 15px;
    right: 15px;
    top: 80px;
    height: 400px;
    padding: 6px;

    .pc-bubble {
      background-color: #2B3757;
      width: 100%;
      height: 52px;
      border-radius: 4px;
      display: flex;
      align-items: center;

      &:not(:first-child) {
        margin-top: 4px;
      }

      .pc-phone-container {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding-top: 8px;

        .pc-phone-title {
          font-size: 12px;
          font-weight: bold;
          color: white;
        }

        .pc-phone-subtitle {
          font-size: 8px;
          color: white;
        }
      }
    }
  }

  .pc-preview-title {
    margin-top: 14px;
    text-align: center;
  }
}
</style>
